import { Injectable } from '@angular/core';
import { Application, FormPage, ProductDefinition, SurveyResult, iApplyFormControl } from '../model';

@Injectable({
    providedIn: 'root'
})
export class DataSharingService {
    private _application: Application;
    private _product: ProductDefinition = <any>{};
    private _formId: string;
    private _applicationId: string;
    private _extendedControls: any = [];
    private _controls: iApplyFormControl[] = [];
    private _currentPage: FormPage;
    private _currentPageIndex: number = 0;
    private _surveyResult: SurveyResult;
    private _externalPopulatedFields: string[] = [];

    constructor() { }

    get application(): Application {
        return this._application;
    }

    set application(val: Application) {
        this._application = val;
    }

    get extendedControls(): any {
        return this._extendedControls;
    }

    set extendedControls(val: any) {
        this._extendedControls = val;
    }

    get surveyResult(): SurveyResult {
        return this._surveyResult;
    }

    set surveyResult(val: SurveyResult) {
        this._surveyResult = val;
    }

    set currentPageIndex(val: number) {
        this._currentPageIndex = val;

        this.updatePageAndControls();
    }

    get currentPage(): FormPage {
        return this._currentPage;
    }

    get controls(): iApplyFormControl[] {
        return this._controls;
    }

    set controls(val: iApplyFormControl[]) {
        this._controls = val;
    }

    get product(): ProductDefinition {
        return this._product;
    }

    set product(val: ProductDefinition) {
        this._product = val;
        this.updatePageAndControls();
    }

    get formId(): string {
        return this._formId;
    }

    set formId(val: string) {
        this._formId = val;
    }

    get applicationId(): string {
        return this._applicationId;
    }

    set applicationId(val: string) {
        this._applicationId = val;
    }

    get externalPopulatedFields(): string[] {
        return this._externalPopulatedFields;
    }

    set externalPopulatedFields(val: string[]) {
        this._externalPopulatedFields = val;
    }

    private updatePageAndControls() {
        if (!this._product ||
            this._product.pages.length <= this._currentPageIndex) {
            return;
        }

        this._currentPage = this._product.pages[this._currentPageIndex];

        let extendedControlsArr = []
            .concat(this._product.formDescription?.referencedControls || [])
            .concat(this._currentPage.controls || []);

        if (this._product?.pages) {
            for (let page of this._product?.pages) {
                if (!page.controls) { continue; }
                extendedControlsArr.push(...page.controls);
            }
        }

        this._extendedControls = extendedControlsArr;
    }
}
